<div class="row form-group" *ngFor="let filter of value; index as index">
	<div class="col-xs-12">
		<div class="row form-group flex">
			<div class="col-xs-2">
				<label>Account Type</label>
			</div>
			<div class="col-xs-3">
				<mat-form-field>
					<mat-label>Select</mat-label>
					<mat-select (selectionChange)="changeSelection($event.value, index)">
						<mat-option *ngFor="let type of props.accountTypes" [value]="type">
							{{type.Description}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="col-xs-3">
				<button mat-icon-button (click)="addFilter()" *ngIf="index === 0">
					<mat-icon>add_box</mat-icon>
				</button>
				<button mat-icon-button (click)="removeFilter(index)" *ngIf="index !== 0">
					<mat-icon>delete</mat-icon>
				</button>
			</div>
		</div>
		<div class="row flex" *ngIf="filter.queries.length > 0">
			<div class="col-xs-2">
				<label>Account Range</label>
			</div>
			<div class="col-xs-9">
				<div class="row form-group" *ngFor="let query of filter.queries; index as QueryIndex">
					<div class="col-xs-3">
						<mat-form-field class="fit-width">
							<mat-label>Select</mat-label>
							<mat-select [(ngModel)]="query.ElementIndex">
								<mat-option *ngFor="let type of (filter.type?.ElementMap | splitText); index as i" [value]="i">
									{{type}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-xs-3">
						<mat-form-field class="fit-width">
							<mat-label>Select</mat-label>
							<mat-select [(ngModel)]="query.queryOptions">
								<mat-option *ngFor="let type of queryOptions" [value]="type.query">
									{{type.displayName}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-xs-3">
						<ng-container
							*ngIf="query.ElementIndex !== undefined && query.ElementIndex >= 0 && filter.type?.Mask | splitText; let splitArray">
							<mat-form-field appearance="outline" class="fit-width">
								<input [(ngModel)]="query.Value" [mask]="(splitArray[query.ElementIndex] ?? '')" type="text" [showMaskTyped]="false"
									[disabled]="query.ElementIndex >= 0" matInput>
							</mat-form-field>
						</ng-container>
					</div>
					<div class="col-xs-3">
						<button mat-icon-button (click)="addQuery(index)" *ngIf="QueryIndex === 0">
							<mat-icon>add_box</mat-icon>
						</button>
						<button mat-icon-button (click)="removeQuery(query, index)" *ngIf="QueryIndex !== 0">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>